import { render, staticRenderFns } from "./SuperAdminMenu.vue?vue&type=template&id=99f8d614&scoped=true"
import script from "./SuperAdminMenu.vue?vue&type=script&lang=js"
export * from "./SuperAdminMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f8d614",
  null
  
)

export default component.exports